import moment from 'jalali-moment'
import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getMoneyPoolManagement = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IMoneyPoolManagement } = await request.get(
        `/moneypool_management/moneypool/${ctx.queryKey[1]}/`
    )
    return data
}

export const getMoneyPoolManagementByWebKey = async (
    ctx: QueryFunctionContext
) => {
    const {
        data,
    }: {
        data: {
            moneypool_id: string
            moneypool_name: string
            share_value_amount: number
        }
    } = await request.get(
        `/moneypool_management/moneypool/web-key/${ctx.queryKey[1]}/`
    )
    return data
}

export const getJoinLinkByMoneypoolId = async (ctx: QueryFunctionContext) => {
    const { data }: { data: { join_link: string } } = await request.get(
        `/moneypool_management/moneypool/join-link/${ctx.queryKey[1]}/`
    )
    return data
}

export const getMoneyPoolManagementBulletins = async (
    ctx: QueryFunctionContext
) => {
    const { data }: { data: Array<IBulletiens> } = await request.get(
        `/moneypool_management/bulletins/${ctx.queryKey[1]}/`
    )
    return data
}

export const getMonyPoolsDetailUsers = async (
    pageParam: number,
    id: string | undefined,
    search: string | undefined
) => {
    const { data }: { data: IGetMoneyPoolUsers } = await request.get(
        `/api/v1/moneypools/${id}/poolships/?cursor=${pageParam}${
            search ? '&q=' + search : ''
        }`
    )
    return data
}

export const getMonyPoolsDetailTransactions = async (
    ctx: QueryFunctionContext
) => {
    // encodeURIComponent, not raw interpolation: the search is now also how a
    // #hashtag is applied, and a bare '#' in a URL starts the FRAGMENT — the
    // query reached the server as `q=` and the list came back unfiltered.
    const query = ctx.queryKey[2]
    const search = query ? `?q=${encodeURIComponent(String(query))}` : ''
    const { data }: { data: IMoneyPoolTransaction } = await request.get(
        `/moneypool_management/moneypool/${ctx.queryKey[1]}/list-cashins-and-cashouts/${search}`
    )
    return data
}

export const getMonyPoolsDetailLoans = async (
    pageParams: number,
    id: undefined | string,
    searchLoans: string
) => {
    const { data }: { data: IMoneyPoolFundLoans } = await request.get(
        `/api/v1/moneypools/${id}/loans/?page=${pageParams}${
            searchLoans ? '&q=' + searchLoans : ''
        }`
    )
    return data
}

export const deleteMoneyPoolCashin = async ({
    moneypoolId,
    cashinId,
}: {
    moneypoolId: number
    cashinId: number
}) => {
    const response = await request.delete(
        `/api/v1/payment/moneypools/${moneypoolId}/moneypool-cashins/${cashinId}/`
    )
    return response
}
export const deleteMoneyPoolCashout = async ({
    moneypoolId,
    cashoutId,
}: {
    moneypoolId: number
    cashoutId: number
}) => {
    const response = await request.delete(
        `/api/v1/payment/moneypools/${moneypoolId}/moneypool-cashouts/${cashoutId}/`
    )
    return response
}
/**
 * Rewrite a transaction's description.
 *
 * The dedicated `/description/` route, not a PUT on the transaction itself:
 * full editing answers 405 because it used to let a manager change the AMOUNT
 * of a settled row and silently desync the fund's ledger. This one writes the
 * description column and nothing else.
 */
export const updateTransactionDescription = async ({
    moneypoolId,
    transactionId,
    isCashin,
    tag,
}: {
    moneypoolId: number
    transactionId: number
    isCashin: boolean
    tag: string
}) => {
    const resource = isCashin ? 'moneypool-cashins' : 'moneypool-cashouts'
    const { data }: { data: { id: number; tag: string } } = await request.patch(
        `/api/v1/payment/moneypools/${moneypoolId}/${resource}/${transactionId}/description/`,
        { tag }
    )
    return data
}

export const getFacilitiesExportExcel = async (
    moneyPool: string | undefined
) => {
    const { data }: { data: IReportFacilitiesExcel } = await request.get(
        `/api/v1/moneypools/${moneyPool}/facilities/`
    )
    return data
}

export const getFinancialDashboard = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IFinancialDashboard } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/financial-dashboard/`
    )
    return data
}

export const ReportEmailExcel = async (
    payload: IFacilitiesReportExcelEmail
) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/facilities/report/`,
        { email: payload.email }
    )
    return data
}

export const getFacilitiesExportExcelDownload = async (
    moneyPool: string | undefined
) => {
    const { data } = await request.get(
        `/api/v1/moneypools/${moneyPool}/facilities/report/download/`
    )
    return data
}

export const ReportEmailExcelCheckTask = async (
    payload: string | undefined
) => {
    const { data } = await request.post(`/api/v1/general/check-task-status/`, {
        task_id: payload,
    })
    return data
}
export const getFacilitiesExportExcelDownloadFinal = async (
    task: string | undefined
) => {
    const { data } = await request.get(
        `/api/v1/general/download-task-result/${task}/`
    )
    return data
}

export const addUserTofund = async (payload: IAddNewUserToFundPayload) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPool}/poolships/`,
        {
            member: {
                has_rated: false,
                is_box_member: false,
                l: [],
                id: 0,
                phone_number: '+98' + payload.phone_number.slice(1),
                first_name: payload.first_name,
                last_name: payload.last_name,
                global_credit: 0.0,
                last_global_credit: -10000.0,
                global_score: 0.0,
                last_global_score: 0.0,
                is_staff: false,
                show_marketing_banner: false,
            },
            number_of_shares: Number(payload.number_of_shares),
            role: 'nrm',
            join_date: moment().format('YYYY-MM-DD'),
            to_be_paid_portion: 0,
            ...(payload.recommender && { recommender: payload.recommender }),
            ...(payload.guarantor && { guarantor: payload.guarantor }),
        }
    )
}

export const addUserToFundByLink = async (
    payload: IAddNewUserToFundPayload
) => {
    const { data } = await request.post(
        `/moneypool_management/${payload.moneyPool}/poolship/join_moneypool_by_link/`,
        {
            member: {
                id: 0,
                phone_number: '+98' + payload.phone_number.slice(1),
                first_name: payload.first_name,
                last_name: payload.last_name,
            },
            number_of_shares: Number(payload.number_of_shares),
            ...(payload.recommender && { recommender: payload.recommender }),
            ...(payload.guarantor && { guarantor: payload.guarantor }),
        }
    )
    return data
}

export const getUserLoansDetail = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IUserloansDetail } = await request.get(
        `/moneypool_management/${ctx.queryKey[1]}/installment/list/${ctx.queryKey[2]}/`
    )
    return data
}

export const addBulletin = async (payload: IAddBulletinPayload) => {
    const { data } = await request.post(
        `/moneypool_management/bulletins/${payload.id}/create`,
        {
            text: payload.text,
            sticker: 3,
        }
    )
    return { data }
}

export const deleteBulletin = async (payload: {
    moneypoolId: string | undefined
    id: number
}) => {
    const response = await request.delete(
        `/moneypool_management/bulletins/${payload.moneypoolId}/${payload.id}/delete`
    )
    return response
}

export const updatePortion = async (payload: {
    moneyPool: String | undefined
    poolship: number
    amount: number
    is_delayed: boolean
}) => {
    const { data } = await request.put(
        `/api/v1/moneypools/${payload.moneyPool}/poolships/${payload.poolship}/reset_poolship_portions/`,
        {
            amount: payload.amount,
            is_delayed: payload.is_delayed,
        }
    )
    return data
}

export const getUnpaidSiblings = async (ctx: QueryFunctionContext) => {
    const { data }: { data: Array<number> } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/loans/${ctx.queryKey[2]}/installments/${ctx.queryKey[3]}/unpaid_siblings/`
    )
    return data
}

export const transferInstalment = async (payload: {
    source_instalment_id: string | undefined
    destination_instalment_index: number
    amount: number
    moneyPools: string | undefined
    loans: string | undefined
}) => {
    const { data } = await request.post(
        `/api/v1/moneypools/${payload.moneyPools}/loans/${payload.loans}/transfer_installment_amount/`,
        {
            source_installment_id: Number(payload.source_instalment_id),
            destination_installment_index: Number(
                payload.destination_instalment_index
            ),
            amount: Number(payload.amount),
        }
    )
    return { data }
}

export const getAdminDashboardStats = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminDashboardStats } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/stats/`
    )
    return data
}

export const getAdminMonthlyCharts = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminMonthlyCharts } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/monthly-charts/?months=${
            ctx.queryKey[2] ?? 12
        }`
    )
    return data
}

// queryKey: ['admin-dashboard-month-detail', id, month, kind]
export const getAdminMonthDetail = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminMonthDetail } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/month-detail/?month=${ctx.queryKey[2]}&kind=${ctx.queryKey[3]}`
    )
    return data
}

// queryKey: ['admin-dashboard-top-members', id, window, rank]
export const getAdminTopMembers = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminTopMembers } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/top-members/?window=${
            ctx.queryKey[2] ?? '12'
        }&rank=${ctx.queryKey[3] ?? 'mean'}`
    )
    return data
}

export const getAdminRoundMembers = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminRoundMembers } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/round-members/?round=${
            ctx.queryKey[2] ?? 'current'
        }`
    )
    return data
}

export const getAdminFollowups = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminFollowups } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/followups/`
    )
    return data
}

// queryKey: ['admin-member-profile', moneypoolId, poolshipId] — کارنامهٔ عضو,
// shown on the اعطای وام screen once a receiver is picked
export const getAdminMemberProfile = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminMemberProfile } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/member-profile/?poolship_id=${ctx.queryKey[2]}`
    )
    return data
}

// queryKey: ['loan-candidates', moneypoolId, requestsOnly, inflation] —
// امتیاز عضو, step 1 of the grant wizard. Both flags are checkboxes on the
// screen and part of the key, so toggling either refetches rather than
// re-ranking a stale list.
export const getLoanCandidates = async (ctx: QueryFunctionContext) => {
    const [, moneypoolId, requestsOnly, inflation] = ctx.queryKey
    const { data }: { data: ILoanCandidates } = await request.get(
        `/api/v1/moneypools/${moneypoolId}/admin-dashboard/loan-candidates/?requests_only=${
            requestsOnly ? 1 : 0
        }&inflation=${inflation ? 1 : 0}`
    )
    return data
}

// queryKey: ['flow-replay', id] — the full financial timeline behind the
// animated بازپخش گردش صندوق page
export const getFlowReplay = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IFlowReplay } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/flow-replay/`
    )
    return data
}

// queryKey: ['admin-member-record', moneypoolId, poolshipId] — کارنامهٔ عضو,
// the manager's full member page (pwa#36). Richer than member-profile, which
// backs the small panel inside the اعطای وام wizard.
export const getAdminMemberRecord = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IAdminMemberRecord } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/member-record/?poolship_id=${ctx.queryKey[2]}`
    )
    return data
}

// queryKey: ['member-score', moneypoolId, poolshipId] — امتیاز عضو for ONE
// member. کارنامهٔ عضو reads this instead of `loan-candidates` when the
// viewer is the member themselves (pwa#61): the candidates list is the
// manager's worklist and hands back the whole fund by name and phone number.
export const getMemberScore = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IMemberScore } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/admin-dashboard/member-score/?poolship_id=${ctx.queryKey[2]}`
    )
    return data
}

// queryKey: ['admin-members', moneypoolId, q, sort, tag, page] — فهرست اعضا.
// Every knob is in the key so changing one refetches rather than re-slicing
// a page that was ranked by something else.
/**
 * One page of فهرست اعضا, called directly.
 *
 * The full list pages with `useInfiniteQuery`, which owns the page number and
 * hands it in as `pageParam` rather than putting it in the query key — so it
 * needs a plain function, not a queryFn that digs the page out of the key.
 */
export const fetchAdminMembers = async (
    moneypoolId: string,
    params: { q: string; sort: TMembersSort; tag: TMembersTag; page: number }
) => {
    const { data }: { data: IAdminMembersList } = await request.get(
        `/api/v1/moneypools/${moneypoolId}/admin-dashboard/members/`,
        { params }
    )
    return data
}

export const getAdminMembers = async (ctx: QueryFunctionContext) => {
    const [, moneypoolId, q, sort, tag, page] = ctx.queryKey as [
        string,
        string,
        string,
        TMembersSort,
        TMembersTag,
        number
    ]
    return fetchAdminMembers(moneypoolId, { q, sort, tag, page })
}
